/**
Slider - Swiper version
--
Documentation :
https://docs.polkarsenal.com/books/theme-wordpress/page/sliderjs
--
Référence à Swiper :
API Doc : https://swiperjs.com/swiper-api
Demos : https://swiperjs.com/demos
*/

// import Swiper from 'swiper/bundle';
import Swiper from 'swiper';

import SliderPreset from './slider-preset';
import {
    Navigation,
    Pagination,
    Scrollbar,
    Controller,
    HashNavigation,
    Autoplay,
    FreeMode,
    EffectFade,
    Mousewheel,
    Thumbs,
} from 'swiper/modules';

const baseClass = 'swiper';

const initSliderSwiper = (target) => {
    let sliders;
    if (target) {
        const $target = $(target);
        sliders = $target.find('.' + baseClass + ', [data-slider]');
        if ($target.is('.' + baseClass + ', [data-slider]')) {
            sliders = sliders.add($target);
        }
    } else {
        sliders = $('.' + baseClass + ', [data-slider]');
    }
    const slidersInstances = [];

    $(sliders).each((i, slider) => {
        slider = $(slider);
        // disable already initialized
        if (slider.hasClass('swiper-initialized')) return true;

        // config shortcuts
        const configShortcuts = {
            nb: 'slidesPerView',
            val: 'initialSlide',
            slidesToShow: 'slidesPerView',
            gap: 'spaceBetween',
            free: 'freeMode',
            dir: 'direction',
            autoplaySpeed: 'autoplay.delay',
            pagination: 'pagination.type', // bullets | fraction | progressbar | custom | datas (retrieve data-pagination of slide as dot)
            fade: (cfg, val) => { if (val === true || val === 'true') cfg.effect = 'fade'; },
            infinite: (cfg, val) => { cfg.loop = (val === true || val === 'true'); },
            fadeOutside: (cfg, val) => { cfg.expendBehavior = (val === true || val === 'true'); },
            fadeoutside: (cfg, val) => { cfg.expendBehavior = (val === true || val === 'true'); },
            mouseWeel: (cfg, val) => { cfg.mousewheel = (val !== false && val !== 'false'); },
            mousewheel: (cfg, val) => { cfg.mousewheel = (val !== false && val !== 'false'); },
            progressCounter: (cfg, val) => { cfg.progressCounter = (val === true || val === 'true'); },
            progresscounter: (cfg, val) => { cfg.progressCounter = (val === true || val === 'true'); },
        };

        /* Container class ; used to find :
            - swiper__button--prev
            - swiper__button--next
            - swiper__scrollbar
            - swiper__pagination
            - slave */
        const container = slider.data('container') ?? '.block, zone';

        // config
        let config = {
            modules: [
                Navigation,
                Pagination,
                Scrollbar,
                Controller,
                HashNavigation,
                FreeMode,
                EffectFade,
                Mousewheel,
                Thumbs,
            ],
            speed: 500,
            effect: 'slide', // slide | fade | cube | coverflow | flip | creative | cards
            direction: 'horizontal', // horizontal | vertical
            slidesPerView: 1, // auto | int
            slidesPerGroupSkip: 1,
            slidesMinimum: 'auto',
            initialSlide: 0,
            loop: false,
            loopedSlides: null,
            rewind: false,
            freeMode: false,

            centerInsufficientSlides: false,
            centeredSlides: false,
            centeredSlidesBounds: false,
            roundLengths: true,
            autoHeight: false,
            cssMode: false,
            cssEase: 'ease',
            spaceBetween: 0,

            preloadImages: true,
            createElements: false,
            watchSlidesProgress: true,
            on: {},

            // Effect configuration
            fadeEffect: {
                crossFade: true,
            },

            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
            },

            cubeEffect: {
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
            },

            // Nav tools
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl: slider
                    .closest(container)
                    .find('.swiper-button-next, .swiper__button--next')
                    .add(slider.find('.swiper-button-next, .swiper__button--next'))
                    .toArray(),
                prevEl: slider
                    .closest(container)
                    .find('.swiper-button-prev, .swiper__button--prev')
                    .add(slider.find('.swiper-button-prev, .swiper__button--prev'))
                    .toArray(),
            },

            scrollbar: {
                el: slider
                    .closest(container)
                    .find('.swiper-scrollbar, .swiper__scrollbar').length
                    ? slider
                        .closest(container)
                        .find('.swiper-scrollbar, .swiper__scrollbar')
                        .toArray()
                    : '.swiper-scrollbar, .swiper__scrollbar',
                hide: true,
            },

            pagination: {
                el: slider
                    .closest(container)
                    .find('.swiper-pagination, .swiper__pagination').length
                    ? slider
                        .closest(container)
                        .find('.swiper-pagination, .swiper__pagination')
                        .toArray()
                    : '.swiper-pagination, .swiper__pagination',
                type: null, // progressbar | bullets | fraction | custom | datas
                clickable: true,
            },

            // Keyboard
            keyboard: {
                enabled: true,
            },

            // Mouse
            slideToClickedSlide: false,
            grabCursor: false,
            mousewheel: {
                invert: true,
                forceToAxis: true,
            },

            // Touch
            allowTouchMove: true,
            edgeSwipeDetection: false,
            edgeSwipeThreshold: 20,

            // Custom
            expendBehavior: false,
            progressCounter: false,
            autoclone: false,
            preset: 'default',
            bem: false,
            breakpoints: {},

            // Lien
            linkMode: 'thumbs', // controller | thumbs
            slave: false,
            master: false,
        };

        // BEM Override class option
        // Require custom CSS to work, it can't work with buildin swiper CSS.
        if (slider.data('bem')) {
            config.wrapperClass = 'swiper__wrapper swiper-wrapper';
            config.slideActiveClass = 'swiper__slide--active';
            config.slideBlankClass = 'swiper__slide--invisible-blank';
            config.slideClass = 'swiper__slide';
            config.slideDuplicateActiveClass =
                'swiper__slide--duplicate swiper__slide--active';
            config.slideDuplicateClass = 'swiper__slide--duplicate';
            config.slideDuplicateNextClass =
                'swiper__slide--duplicate swiper__slide--next';
            config.slideDuplicatePrevClass =
                'swiper__slide--duplicate swiper__slide--prev';
            config.slideNextClass = 'swiper__slide--next';
            config.slidePrevClass = 'swiper__slide--prev';
            config.slideVisibleClass = 'swiper__slide--visible';
            config.noSwipingClass = 'swiper--no-swiping';
            config.containerModifierClass = 'swiper--';
            config.navigation.disabledClass = 'swiper__button--disabled';
            config.navigation.hiddenClass = 'swiper__button--hidden';
            config.navigation.lockClass = 'swiper__button--lock';
            config.pagination.bulletClass = 'swiper__bullet';
            config.pagination.bulletActiveClass = 'swiper__bullet--active';
            config.pagination.clickableClass = 'swiper__pagination--clickable';
            config.pagination.currentClass = 'swiper__pagination--current';
            config.pagination.hiddenClass = 'swiper__pagination--hidden';
            config.pagination.horizontalClass =
                'swiper__pagination--horizontal';
            config.pagination.lockClass = 'swiper__pagination--lock';
            config.pagination.modifierClass = 'swiper__pagination--';
            config.pagination.progressbarFillClass =
                'swiper__pagination--progressbar--fill';
            config.pagination.progressbarOppositeClass =
                'swiper__pagination--progressbar--opposite';
            config.pagination.totalClass = 'swiper__pagination--total';
            config.pagination.verticalClass = 'swiper__pagination--vertical';
        }

        // Config override json
        if (slider.data('slider')) {
            let jsonData = slider.data('slider');
            if (typeof jsonData === 'string') {
                jsonData = jsonData.replace(/'/g, '"');
                jsonData = JSON.parse(jsonData);
            }
            $.extend(config, jsonData);
        }

        // Config override shortcuts
        $.each(configShortcuts, (index) => {
            if (typeof slider.data(index.toLowerCase()) !== 'undefined') {
                const shortcutVal = configShortcuts[index];
                const rawVal = slider.data(index.toLowerCase());
                if (typeof shortcutVal === 'function') {
                    shortcutVal(config, rawVal);
                } else {
                    assignValueByShortcut(
                        config,
                        shortcutVal,
                        rawVal
                    );
                }
            }
        });

        // Config override datas
        $.each(config, (index) => {
            const isShortcut = Object.keys(configShortcuts).includes(index);
            if (
                typeof slider.data(index.toLowerCase()) !== 'undefined' &&
                !isShortcut
            ) {
                config[index] = slider.data(index.toLowerCase());
            }
        });

        // Config preset & Responsive templates
        const presets = (typeof window !== "undefined" && window.SliderPreset) || (typeof global !== "undefined" && global.SliderPreset) || SliderPreset; if (config.preset && presets && presets[config.preset]) {
            const currentPreset = presets[config.preset];
            config = currentPreset(config);
        }

        // Expended behavior event
        if (config.expendBehavior) {
            config.on.loopFix = function () {
                expendedBehaviorInterval(slider, config);
            };
        }

        // pagination mode data
        // Retrieve "data-pagination" of slide as dot content
        if (config.pagination && config.pagination.type == 'datas') {
            config.pagination.type = 'bullets';
            config.pagination.renderBullet = function (index, className) {
                return (
                    '<span class="' +
                    className +
                    '"><span>' +
                    this.slides[index].getAttribute('data-pagination') +
                    '</span></span>'
                );
            };
        }

        // Autoplay
        if (
            slider.data('autoplay') != false &&
            slider.data('autoplayspeed') > 0
        ) {
            config.modules.push(Autoplay);
        } else {
            delete config.autoplay;
        }

        // remove pagination settings
        if (!config.pagination || !config.pagination.type) {
            delete config.pagination;
        }

        // Prepare Markup
        if (!slider.find('> .swiper-wrapper').length) {
            const $slides = slider.children().not('.swiper-button-prev, .swiper-button-next, .swiper__button, .swiper-pagination, .swiper__pagination, .swiper__counters, .slick__counters');
            const $wrapper = $('<div class="swiper-wrapper swiper__wrapper"></div>');
            $slides.addClass('swiper-slide swiper__slide').appendTo($wrapper);
            slider.prepend($wrapper);

            if (config.pagination && config.pagination.type && !slider.find('.swiper__pagination, .swiper-pagination').length) {
                slider.append('<div class="swiper__pagination"></div>');
            }
            if (config.progressCounter && !slider.find('.swiper__counters, .slick__counters').length) {
                slider.append('<div class="swiper__counters slick__counters"><div class="swiper__counter swiper__counter--current slick__counter slick__counter--current">1</div><div class="swiper__counter swiper__counter--count slick__counter slick__counter--count">1</div></div>');
            }
        } else if (config.progressCounter && !slider.find('.swiper__counters, .slick__counters').length) {
            slider.append('<div class="swiper__counters slick__counters"><div class="swiper__counter swiper__counter--current slick__counter slick__counter--current">1</div><div class="swiper__counter swiper__counter--count slick__counter slick__counter--count">1</div></div>');
        }

        // Navigation arrows auto-generate if missing and arrows not disabled
        if (slider.data('arrows') !== false && config.arrows !== false) {
            const hasNext = slider.closest(container).find('.swiper-button-next, .swiper__button--next').length || slider.find('.swiper-button-next, .swiper__button--next').length;
            const hasPrev = slider.closest(container).find('.swiper-button-prev, .swiper__button--prev').length || slider.find('.swiper-button-prev, .swiper__button--prev').length;
            if (!hasNext && !hasPrev) {
                slider.append('<div class="swiper__button swiper__button--prev swiper-button-prev"></div><div class="swiper__button swiper__button--next swiper-button-next"></div>');
            }
            config.navigation = config.navigation || {};
            config.navigation.nextEl = slider.closest(container).find('.swiper-button-next, .swiper__button--next').add(slider.find('.swiper-button-next, .swiper__button--next')).toArray();
            config.navigation.prevEl = slider.closest(container).find('.swiper-button-prev, .swiper__button--prev').add(slider.find('.swiper-button-prev, .swiper__button--prev')).toArray();
        } else {
            delete config.navigation;
        }

        // Slide clones
        let cloneCount = 0;
        if (
            config.autoclone &&
            (config.slidesMinimum > slider.find('.swiper-slide').length ||
                config.slidesMinimum === 'auto')
        ) {
            let minSlides = config.slidesMinimum;
            if (config.slidesMinimum === 'auto') {
                minSlides = config.loopedSlides
                    ? config.loopedSlides * 2
                    : config.slidesPerView * 2; // nombre minimal de slides souhaité
            }
            const $slides = slider.find('.swiper-slide'); // récupération des slides existantes
            if ($slides.length < minSlides) {
                // vérification si le nombre de slides est insuffisant
                const slideClonesSrc = slider.find('.swiper-slide');
                if (slideClonesSrc.length) {
                    while (slider.find('.swiper-slide').length < minSlides) {
                        cloneCount += slideClonesSrc.length;
                        const slideClones = slideClonesSrc.clone();
                        slideClones
                            .addClass('swiper-slide-clone')
                            .data('original', slideClonesSrc);
                        slider.find('.swiper-wrapper').append(slideClones);
                    }

                    if (
                        config.pagination &&
                        config.pagination.type == 'bullets'
                    ) {
                        config.on.slideChange = function (swiper) {
                            $(swiper.pagination.el)
                                .find('.' + config.pagination.bulletActiveClass)
                                .removeClass(
                                    config.pagination.bulletActiveClass
                                );
                            $(
                                swiper.pagination.bullets[
                                    swiper.realIndex %
                                        swiper.pagination.bullets.length
                                ]
                            ).addClass(config.pagination.bulletActiveClass);
                        };
                    }
                }
            }
        }

        // Lock status
        config.on.lock = function () {
            slider
                .addClass(baseClass + '-locked')
                .removeClass(baseClass + '-unlocked');
        };

        config.on.unlock = function () {
            slider
                .addClass(baseClass + '-unlocked')
                .removeClass(baseClass + '-locked');
        };

        // Ease
        slider
            .find('.swiper-wrapper')
            .css('transition-timing-function', config.cssEase);

        // Prevent double navigation for slave that should also assigned to master
        if (config.slave) {
            delete config.navigation;
            delete config.autoplay;
        }

        // Aux (for master or slave link)
        let aux = null;
        if (config.master) {
            aux = slider
                .closest(container)
                .find('.' + baseClass)
                .not('[data-master="true"]')
                .first();
        } else if (config.slave) {
            aux = slider
                .closest(container)
                .find('.' + baseClass)
                .not('[data-slave="true"]')
                .first();
        }

        // Config prepare
        const currentSliderDatas = {
            element: slider,
            config,
            clone: cloneCount,
            aux,
        };

        // add to slidersInstances stack
        if (
            (config.linkMode == 'thumbs' && config.slave) ||
            (config.linkMode == 'controller' && config.master)
        ) {
            slidersInstances.unshift(currentSliderDatas);
        } else {
            slidersInstances.push(currentSliderDatas);
        }
    });

    // Init each sliders
    slidersInstances.forEach((value, index) => {
        slidersInstances[index].swiper = swiperStart(
            value.element,
            value.config,
            value.clone,
            value.aux
        );
    });
};

function swiperStart(slider, config, cloneCount, aux) {
    // Master
    if (config.linkMode == 'thumbs' && config.master) {
        config.thumbs = {
            swiper: aux[0],
            slideThumbActiveClass: config.bem
                ? 'swiper__slide--selected'
                : 'swiper-slide-thumb-active',
            thumbsContainerClass: config.bem
                ? 'swiper--thumbs'
                : 'swiper-thumbs',
        };
    }

    // Init swiper
    const currentSlider = new Swiper(slider[0], config);
    slider.data('swiper', currentSlider);

    // Progress counter update
    if (config.progressCounter) {
        const updateCounter = function (swiper) {
            const count = swiper.slides ? swiper.slides.length : 0;
            slider.find('.swiper__counter--count, .slick__counter--count').text(count);
            slider.find('.swiper__counter--current, .slick__counter--current').text(((swiper.realIndex ?? swiper.activeIndex ?? 0) + 1));
        };
        currentSlider.on('init', updateCounter);
        currentSlider.on('slideChange', updateCounter);
        updateCounter(currentSlider);
    }

    // Slave
    if (config.linkMode == 'controller' && config.slave) {
        currentSlider.controller.control = aux.data('swiper');
        aux.data('swiper').controller.control = currentSlider;
    }

    // Remove cloned dots
    if (
        cloneCount &&
        currentSlider.pagination &&
        currentSlider.pagination.el &&
        config.pagination &&
        config.pagination.type == 'bullets'
    ) {
        for (let i = cloneCount; i > 0; i--) {
            currentSlider.pagination.bullets.pop();
            currentSlider.pagination.el.removeChild(
                currentSlider.pagination.el.lastChild
            );
        }
    }

    // Expended behavior
    function expendedBehaviorInterval(slider, config) {
        const slides = slider.find('.' + (config.slideClass || 'swiper-slide'));
        const slideParent = slides.first().closest('.' + baseClass);

        const wrapperSelector = config.wrapperClass ? '.' + config.wrapperClass.split(' ')[0] : '.swiper-wrapper';
        if (
            slideParent.find(wrapperSelector).css('transform') !=
            slideParent.data('current')
        ) {
            const slideParentLeft = slideParent.offset().left - 20;
            const slideParentRight =
                slideParent.offset().left + slideParent.width() + 20;

            slideParent.data(
                'current',
                slideParent.find(wrapperSelector).css('transform')
            );

            let firstVisible = 1;
            slides.each(function () {
                const slide = $(this);
                const slideLeft = slide.offset().left - 0;
                const slideRight = slide.offset().left + 0 + slide.width();

                let newOpacity = 1;
                const applyClass = {
                    next: false,
                    prev: false,
                    hidden: false,
                    visible: false,
                };

                if (slideLeft < slideParentLeft) {
                    applyClass.hidden = true;
                    newOpacity = slideParentLeft - slideLeft;
                    newOpacity = 1 - newOpacity * 0.004;
                } else if (slideRight > slideParentRight) {
                    applyClass.hidden = true;
                    newOpacity = slideRight - slideParentRight;
                    newOpacity = 1 - newOpacity * 0.004;

                    if (!firstVisible) {
                        firstVisible = 1;
                        applyClass.next = true;
                    }
                } else {
                    applyClass.visible = true;

                    if (firstVisible) {
                        firstVisible = 0;
                        applyClass.prev = true;
                        slider
                            .find(
                                '.' +
                                    baseClass +
                                    '-counter-current, .' +
                                    baseClass +
                                    '__counter--current, .slick__counter--current'
                            )
                            .text((slide.data('swiper-index') ?? slide.index()) + 1);
                    }
                }

                // apply class
                const slidePrefix = config.slideClass || 'swiper-slide';
                Object.entries(applyClass).forEach(([key, value]) => {
                    const currentClass = slidePrefix + '-' + key;
                    if (slide.hasClass(currentClass) && !value) {
                        slide.removeClass(currentClass);
                    } else if (!slide.hasClass(currentClass) && value) {
                        slide.addClass(currentClass);
                    }
                });

                if (newOpacity < 0) newOpacity = 0;

                if (slide.css('opacity') != newOpacity) {
                    slide.css('opacity', newOpacity);
                }
            });
        }
    }

    /* fade elements when go outside */
    if (config.expendBehavior) {
        setInterval(() => {
            expendedBehaviorInterval(slider, config);
        }, 10);
    }

    /* auto pause to avoid page content moving when you are scrolled bellow de swiper */
    if (config.autoHeight && config.autoplay && config.autoplay.delay) {
        const swiperScrollPause = function () {
            if ($(this).scrollTop() > slider.offset().top) {
                currentSlider.autoplay.pause();
            } else {
                currentSlider.autoplay.resume();
            }
        };
        $(window).scroll(swiperScrollPause);
    }

    // Autoplay
    if (
        slider.data('autoplay') != false &&
        slider.data('autoplayspeed') > 0
    ) {
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                currentSlider.autoplay.resume();
            }
        });
    }

    return currentSlider;
}

// Util
function assignValueByShortcut(object, key, value) {
    const path = key.split('.');
    let current = object;
    path.forEach((p, i) => {
        if (i === path.length - 1) {
            current[p] = value;
        } else if (typeof current[p] === 'undefined') {
            current[p] = {};
        }
        current = current[p];
    });
}

// Global exposures for backward and forward compatibility
if (typeof window !== 'undefined') {
    window.initSliderSwiper = initSliderSwiper;
    window.sliderSwiperInit = initSliderSwiper;
    window.slickSliderInit = initSliderSwiper;
}
if (typeof global !== 'undefined') {
    global.initSliderSwiper = initSliderSwiper;
    global.sliderSwiperInit = initSliderSwiper;
    global.slickSliderInit = initSliderSwiper;
}

export default initSliderSwiper;
